import type { FaireProductEntity } from "../../entity_types/product";

export const p_d4qtcdysde: FaireProductEntity = {
  token: "p_d4qtcdysde",
  type: "product",
  name: "Birthday Candles – 100% Pure Beeswax – Hand-Dipped",
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/2e1983d612acb2462077dcf55adeff928f099b6674e7383028617c2b0e7d27b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d1a2de0ffbd9a825c4df98733dd6e47a44aa0de5800c4ff6652e890da07fab0.jpeg",
    "https://cdn.faire.com/fastly/27b4ddb623b2ec7c8c406b1235624b90eac8df849269128c407c7fc805620f6a.jpeg",
    "https://cdn.faire.com/fastly/fadd5ede92556ffed47bd324de16063cdcfe5612517906e2882032a551ed87a8.jpeg",
  ],
  priceDollars: 37.8,
  description:
    "Celebrate naturally with our 100% Pure Beeswax Birthday Candles, hand-dipped for a timeless look. Free of toxins, paraffin, and synthetic materials, these eco-friendly candles are the safe and sustainable choice for cakes and desserts. Each set includes 12 candles with a slow, clean burn that’s perfect for multiple uses. Available in natural beeswax or vibrant multi-color packs (red, orange, green, and blue).\n\nProduct Details:\n\n-Set of 12 hand-dipped beeswax candles\n-Dimensions: 3” tall x 0.25” diameter\n-Burns cleanly for several minutes per candle\n\nPerfect for birthdays, parties, and special occasions. Enjoy the sweet, subtle scent of beeswax while adding a touch of elegance to any celebration.\n\nLearn more at BigDipperWaxWorks.com.",
  tags: [],
  msrpDollars: 75.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:40.716Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
